export enum RegisterCloseBehaviour {
    RedirectToHome = 'redirect-to-home',
    CloseDialog = 'close-dialog',
}
